module.exports = __webpack_public_path__ + "static/media/comma-fill-sharp.ad6a480b.svg";